import {
  isProdEnvironment,
  isStageEnvironment
} from '_clean-code/utils/environments';
import React from 'react';
import { Helmet } from 'react-helmet';

const UserGuidingScript = () => {
  if (isStageEnvironment()) {
    return (
      <Helmet>
        <script>
          {`(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify', 'hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','XT7103651E1QID');`}
        </script>
      </Helmet>
    );
  }

  if (isProdEnvironment()) {
    return (
      <Helmet>
        <script>
          {`(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','SLO106964FC9ID');`}
        </script>
      </Helmet>
    );
  }

  return null;
};

export default UserGuidingScript;
